import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },
  bottomText: {
    textAlign: 'center',
  },
  endButton: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      display: 'flex',
      margin: '10px',
      padding: '5px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      width: '50%',
      borderRadius: '15px',
      backgroundColor: props.baseColors.secondary,
      cursor: 'pointer',
    }
  },
  endButtonSpan: {
    display: 'inline-block',
    letterSpacing: '0.05em',
    lineHeight: '38px',
    fontSize: '25px',
    color: '#ffffff',
    fontFamily: 'Mulish',
  },
  failedIcon: (props: { isMobile: boolean }) => {
    return {
      maxHeight: '230px',
      margin: '15px 5px',
      height: !props.isMobile ? '230px' : undefined,
    }
  },
}))

export default buildStyles
